import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, toDisplayString as _toDisplayString, createVNode as _createVNode } from "vue"
import _imports_0 from './assets/images/cad-assist.png'
import _imports_1 from './assets/images/statistics.png'
import _imports_2 from './assets/images/home.png'
import _imports_3 from './assets/images/chat.png'
import _imports_4 from './assets/images/mail.png'
import _imports_5 from './assets/images/logout.png'
import _imports_6 from './assets/images/user.png'


const _hoisted_1 = { id: "app" }
const _hoisted_2 = {
  key: 1,
  id: "display"
}
const _hoisted_3 = {
  key: 0,
  style: {"margin-top":"25px"},
  class: "showHover",
  src: _imports_0
}
const _hoisted_4 = /*#__PURE__*/_createElementVNode("div", { style: {"flex":"1"} }, null, -1)
const _hoisted_5 = /*#__PURE__*/_createElementVNode("img", { src: _imports_1 }, null, -1)
const _hoisted_6 = {
  key: 0,
  class: "showHover"
}
const _hoisted_7 = /*#__PURE__*/_createElementVNode("img", { src: _imports_2 }, null, -1)
const _hoisted_8 = {
  key: 0,
  class: "showHover"
}
const _hoisted_9 = /*#__PURE__*/_createElementVNode("img", { src: _imports_3 }, null, -1)
const _hoisted_10 = {
  key: 0,
  class: "showHover"
}
const _hoisted_11 = /*#__PURE__*/_createElementVNode("img", { src: _imports_4 }, null, -1)
const _hoisted_12 = {
  key: 0,
  class: "showHover"
}
const _hoisted_13 = /*#__PURE__*/_createElementVNode("div", { style: {"flex":"1"} }, null, -1)
const _hoisted_14 = /*#__PURE__*/_createElementVNode("img", { src: _imports_5 }, null, -1)
const _hoisted_15 = {
  key: 0,
  class: "showHover"
}
const _hoisted_16 = { class: "top-bar" }
const _hoisted_17 = /*#__PURE__*/_createElementVNode("div", null, null, -1)
const _hoisted_18 = {
  key: 0,
  class: "top-bar-container"
}
const _hoisted_19 = { class: "top-bar-content" }
const _hoisted_20 = { style: {"margin-right":"24px"} }
const _hoisted_21 = { style: {"margin-top":"4px","opacity":"0.5"} }
const _hoisted_22 = { class: "circle-container" }
const _hoisted_23 = {
  key: 0,
  src: _imports_6
}
const _hoisted_24 = ["src"]
const _hoisted_25 = { class: "app-content-container" }
const _hoisted_26 = {
  key: 0,
  class: "loading"
}
const _hoisted_27 = /*#__PURE__*/_createElementVNode("div", { class: "overlay" }, null, -1)
const _hoisted_28 = /*#__PURE__*/_createElementVNode("div", { class: "circle" }, null, -1)
const _hoisted_29 = /*#__PURE__*/_createElementVNode("p", { class: "loading-text" }, "L O A D I N G", -1)
const _hoisted_30 = [
  _hoisted_27,
  _hoisted_28,
  _hoisted_29
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_redirecting_view = _resolveComponent("redirecting-view")!
  const _component_router_view = _resolveComponent("router-view")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    ($setup.isRedirecting)
      ? (_openBlock(), _createBlock(_component_redirecting_view, {
          key: 0,
          loadingText: $setup.loadingText
        }, null, 8, ["loadingText"]))
      : (_openBlock(), _createElementBlock("div", _hoisted_2, [
          ($setup.isAuthenticated)
            ? (_openBlock(), _createElementBlock("div", {
                key: 0,
                class: _normalizeClass([{ 'menu-bar': true }, "menu-bar"])
              }, [
                (!$setup.isOnMobile)
                  ? (_openBlock(), _createElementBlock("img", _hoisted_3))
                  : _createCommentVNode("", true),
                _hoisted_4,
                (
            $setup.user.roleName != null &&
            $setup.user.roleName.String.toLowerCase().includes('admin')
          )
                  ? (_openBlock(), _createElementBlock("div", {
                      key: 1,
                      class: _normalizeClass(["menu-item", { active: _ctx.$route.path.includes('/dashboard') }]),
                      onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => ($setup.goToDashboard && $setup.goToDashboard(...args)))
                    }, [
                      _hoisted_5,
                      (!$setup.isOnMobile)
                        ? (_openBlock(), _createElementBlock("p", _hoisted_6, "Dashboard"))
                        : _createCommentVNode("", true)
                    ], 2))
                  : _createCommentVNode("", true),
                _createElementVNode("div", {
                  class: _normalizeClass(["menu-item", { active: _ctx.$route.path === '/' }]),
                  onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => ($setup.goToHome && $setup.goToHome(...args)))
                }, [
                  _hoisted_7,
                  (!$setup.isOnMobile)
                    ? (_openBlock(), _createElementBlock("p", _hoisted_8, "Home"))
                    : _createCommentVNode("", true)
                ], 2),
                _createElementVNode("div", {
                  class: _normalizeClass(["menu-item", {
            active: _ctx.$route.path === '/agent' || _ctx.$route.path.includes('/agent/'),
          }]),
                  onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => ($setup.goToAgent && $setup.goToAgent(...args)))
                }, [
                  _hoisted_9,
                  (!$setup.isOnMobile)
                    ? (_openBlock(), _createElementBlock("p", _hoisted_10, "Chat"))
                    : _createCommentVNode("", true)
                ], 2),
                _createElementVNode("div", {
                  class: "menu-item",
                  onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => ($setup.reportIssue && $setup.reportIssue(...args)))
                }, [
                  _hoisted_11,
                  (!$setup.isOnMobile)
                    ? (_openBlock(), _createElementBlock("p", _hoisted_12, "Report"))
                    : _createCommentVNode("", true)
                ]),
                _hoisted_13,
                _createElementVNode("div", {
                  style: {"margin-bottom":"25px"},
                  class: "menu-item",
                  onClick: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => ($setup.logout && $setup.logout(...args)))
                }, [
                  _hoisted_14,
                  (!$setup.isOnMobile)
                    ? (_openBlock(), _createElementBlock("p", _hoisted_15, "Sign Out"))
                    : _createCommentVNode("", true)
                ])
              ]))
            : _createCommentVNode("", true),
          _createElementVNode("div", _hoisted_16, [
            _hoisted_17,
            ($setup.user.username)
              ? (_openBlock(), _createElementBlock("div", _hoisted_18, [
                  _createElementVNode("div", _hoisted_19, [
                    _createElementVNode("h4", _hoisted_20, _toDisplayString(`Welcome, ${$setup.user.username}`), 1),
                    _createElementVNode("h6", _hoisted_21, _toDisplayString($setup.user.email), 1)
                  ]),
                  _createElementVNode("div", _hoisted_22, [
                    (!$setup.user.localImageProfile)
                      ? (_openBlock(), _createElementBlock("img", _hoisted_23))
                      : (_openBlock(), _createElementBlock("img", {
                          key: 1,
                          src: $setup.user.localImageProfile
                        }, null, 8, _hoisted_24))
                  ])
                ]))
              : _createCommentVNode("", true)
          ]),
          _createElementVNode("div", _hoisted_25, [
            _createVNode(_component_router_view, { id: "router-view" }),
            ($setup.isLoading)
              ? (_openBlock(), _createElementBlock("div", _hoisted_26, _hoisted_30))
              : _createCommentVNode("", true)
          ])
        ]))
  ]))
}